import timelineItemClasses from "@mui/lab/TimelineItem/timelineItemClasses";
import { SxProps } from "@mui/material";
import zIndex from "@mui/material/styles/zIndex";

const BACKDROP_WRAPPER: SxProps = (theme: any) => ({
  zIndex: zIndex.drawer + 1,
  marginTop: theme.spacing(9),
  background: "rgba(241, 244, 249, 0.54)",
});

const LOADING_WRAPPER: SxProps = (theme: any) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  color: "#0F3D61",
});

const APPBAR: SxProps = {
  height: 72,
  boxShadow: "none",
  background: "rgba(241, 244, 249, 0.54)",
  alignItems: "center",
};

const TOOLBAR_WRAPPER: SxProps = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexGrow: 1,
  height: 56,
  position: "absolute",
  left: 32,
  right: 32,
  top: 16,
  padding: "12px 24px",
  background: "#0F3D61",
  borderRadius: "8px",
};

const HEADER_ICON: SxProps = {
  height: 24,
  width: 24,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: 0,
};

const AVATAR_INITIALS: SxProps = {
  background: "rgba(255, 255, 255, 0.16)",
  color: "#FFFFFF",
  height: 32,
  width: 32,
  fontSize: 12,
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0.44px",
};

const USERNAME: SxProps = {
  fontWeight: 500,
  fontSize: 14,
  lineHeight: "16px",
  marginBottom: 1,
  color: "#282C36",
};

const EMAIL: SxProps = {
  fontWeight: 500,
  fontSize: 12,
  lineHeight: "16px",
  color: "#818697",
};

const USER_MENU_ITEM: SxProps = {
  fontWeight: 500,
  fontSize: 14,
  lineHeight: "19px",
  color: "#282C36",
};

const USER_MENU_DIVIDER: SxProps = {
  // marginX: 2,
  boxSizing: "border-box",
  border: "1px solid rgba(15, 61, 97, 0.08)",
};

const APP_CONTAINER: SxProps = {
  marginTop: 9,
  position: "relative",
  background: "rgba(241, 244, 249, 0.54)",
};

const APP_SUB_CONTAINER: SxProps = {
  maxWidth: 1600,
  minWidth: 1300,
  width: "100%",
  margin: "0 auto",
};

const UPLOAD_TITLE: SxProps = {
  fontSize: 24,
  lineHeight: "32px",
  fontWeight: 600,
  color: "#282C36",
};

const UPLOAD_SUBTITLE: SxProps = {
  fontSize: 16,
  lineHeight: "22px",
  fontWeight: 600,
  color: "#282C36",
};

const DROPZONE_WRAPPER: SxProps = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  marginY: 3,
};

const DROPZONE: SxProps = {
  width: "100%",
  minHeight: 104,
  background: "#FDFDFD",
  border: "1px dashed #D5D7DC",
  boxSizing: "border-box",
  borderRadius: "12px",
  padding: "12px 0px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  flex: 1,
};

const DROPZONE_FILE: SxProps = {
  width: "100%",
  height: "100%",
  background: "#FDFDFD",
  border: "1px dashed #D5D7DC",
  boxSizing: "border-box",
  borderRadius: "12px",
  padding: 3,
  display: "flex",
  flexDirection: "column",
  flex: 1,
};

const UPLOAD_DROP_TEXT: SxProps = {
  fontWeight: 500,
  fontSize: 14,
  lineHeight: "19px",
  marginY: "12px",
  color: "#6F7784",
};

const UPLOAD_FILE_CONTAINER: SxProps = {
  background: "#FFFFFF",
  border: "1px solid rgba(213, 215, 220, 0.74)",
  borderRadius: "4px",
  overflow: "auto",
  maxHeight: 350,
};

const UPLOAD_FILE_NAME: SxProps = {
  fontWeight: 500,
  fontSize: 14,
  lineHeight: "19px",
  color: "#282C36",
};

const UPLOAD_FILE_SIZE: SxProps = {
  fontWeight: 500,
  fontSize: 10,
  lineHeight: "14px",
  color: "#6F7784",
  textTransform: "uppercase",
};

const UPLOAD_BUTTON: SxProps = {
  height: 34,
  background: "#0F3D61",
  borderRadius: "4px",
  color: "#FFFFFF",
  fontWeight: 500,
  fontSize: 14,
  lineHeight: "18px",
  textTransform: "capitalize",
  "&:hover": {
    background: "#0F3D61",
  },
};

const UPLOAD_DEL_BTN: SxProps = {
  width: 32,
  height: 34,
  background: "rgba(15, 61, 97, 0.04)",
  borderRadius: "4px",
  "&:hover": {
    background: "rgba(15, 61, 97, 0.04)",
  },
};

const UPLOAD_CAPTION: SxProps = {
  fontSize: 12,
  lineHeight: "16px",
  fontWeight: 500,
  color: "#6F7784",
};

const PRODUCT_WRAPPER: SxProps = (theme: any) => ({
  display: "flex",
  flexDirection: "column",
  height: "calc(100vh - 72px)",
  padding: theme.spacing(2, 4),
});

const PRODUCT_FILTER_WRAPPER: SxProps = {
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "12px",
  padding: "9px 16px",
  background: "#FFFFFF",
  boxShadow: "0px 3px 20px rgba(40, 44, 54, 0.04)",
  borderRadius: "8px",
  maxHeight: 52,
};

const BASE_INPUT: SxProps = {
  "& .MuiInputBase-input": {
    position: "relative",
    fontSize: 12,
    lineHeight: "16px",
    padding: "0 !important",
    color: "#0F3D61",
  },
};

const INPUT_WRAPPER: SxProps = {
  background: "rgba(241, 244, 249, 0.74)",
  width: 210,
  padding: 1,
  border: "1px solid rgba(240, 247, 236, 0.2)",
  borderRadius: "4px",
};

const ITEM_CARD_WRAPPER: SxProps = {
  flex: 1,
  width: "100%",
  height: "auto",
  padding: "12px 16px",
  background: "#FFFFFF",
  borderRadius: "8px",
  boxShadow: "none",
  "&:hover": {
    boxShadow: "0px 0px 16px rgba(40, 44, 54, 0.08)",
  },
};

const PAGINATION_WRAPPER: SxProps = {
  minHeight: 48,
  padding: "8px 15px 0",
  background: "#FFFFFF",
  borderWidth: "1px 1px 0px 1px",
  borderStyle: "solid",
  borderColor: "#F1F2F3",
  borderRadius: "8px 8px 0px 0px",
  marginTop: "4px",
  overflow: "hidden",
  alignItems: "center",
};

const PAGINATION_CONTAINER: SxProps = {
  "& .MuiToolbar-root": {
    minHeight: 0,
    padding: 0,
    "& .MuiInputBase-root": {
      marginTop: "2px",
    },
    "& .MuiTablePagination-select": {
      fontSize: 12,
      lineHeight: "16px",
      fontWeight: 500,
      color: "#282C36",
    },
  },
  "& .MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel": {
    padding: 0,
    margin: 0,
    color: "#282C36",
    fontSize: 12,
    lineHeight: "16px",
    fontWeight: 500,
  },
};

const ITEM_CARD_LABEL: SxProps = {
  fontSize: 12,
  lineHeight: "16px",
  fontWeight: 500,
  color: "#6F7784",
  textTransform: "none",
};

const ITEM_CARD_VALUE: SxProps = {
  fontSize: 13,
  lineHeight: "24px",
  fontWeight: 500,
  color: "#282C36",
  textTransform: "none",
};

const ITEM_CARD_SELECT_MENU: SxProps = {
  fontSize: 13,
  lineHeight: "1.5em",
  fontWeight: 500,
  color: "#282C36",
  "&:focus": {
    background: "rgba(111, 119, 132, 0.03)",
  },
  ":before": { borderBottomColor: "transparent" },
  // // underline when selected
  ":after": {
    borderBottomColor: "#0047D1",
  },
  "&.Mui-error": {
    ":after": {
      borderBottomColor: "#BA0C2F",
    },
  },
};

const SAVE_BTN: SxProps = {
  minWidth: 96,
  height: 34,
  background: "#077942",
  borderRadius: "4px",
  boxShadow: "none",
  fontSize: 12,
  lineHeight: "24px",
  fontWeight: 500,
  color: "#F1F2F3",
  letterSpacing: "0.44px",
  textTransform: "none",
  "&:hover": {
    background: "#077942",
  },
};

const SELECTION_TEXT: SxProps = {
  fontSize: 12,
  lineHeight: "24px",
  fontWeight: 500,
  color: "#686C7E",
  fontStyle: "italic",
};

const ITEM_CARD_DIVIDER: SxProps = {
  background: "rgba(15, 61, 97, 0.08)",
  height: 16,
  marginY: 0,
};

const ITEM_CARD_PAPER: SxProps = {
  maxHeight: 32 * 4.5,
  width: "70%",
  maxWidth: "calc(70% - 50px)",
  paddingX: 1,
  background: "#FFFFFF",
  border: "1px solid #F1F2F3",
  boxShadow: "0px 1px 10px rgba(171, 174, 186, 0.24)",
  borderRadius: "0px 0px 4px 4px",
};

const ITEM_CARD_MENU_ITEM: SxProps = {
  fontSize: 12,
  lineHeight: "16px",
  fontWeight: 500,
  whiteSpace: "normal",
  color: "#686C7E",
};

const UPLOAD_CONTAINER: SxProps = {
  padding: 3,
  background: "#FFFFFF",
  borderRadius: "12px",
  flex: 0.33,
  height: "100%",
  maxWidth: 501,
};

const UPLOAD_NAVIGATION_BTN: SxProps = {
  height: 34,
  background: "#276B8B",
  border: "1px solid #276B8B",
  borderRadius: "34px",
  color: "#F1F2F3",
  fontWeight: 500,
  fontSize: 14,
  lineHeight: "24px",
  textTransform: "capitalize",
  "&:hover": {
    background: "#276B8B",
  },
};

const UPLOAD_RESET_BTN: SxProps = {
  height: 34,
  background: "#F1F4F9",
  border: "1px solid #F1F4F9",
  borderRadius: "4px",
  color: "#0F3D61",
  fontWeight: 500,
  fontSize: 14,
  lineHeight: "24px",
  textTransform: "capitalize",
  "&:hover": {
    background: "#F1F4F9",
  },
};

const UPLOAD_DATA_CONTAINER: SxProps = {
  background: "#FFFFFF",
  borderRadius: "12px",
  padding: 3,
  flex: 0.7,
  height: "100%",
};

const UPLOAD_FILTER_BUTTON: SxProps = {
  height: 32,
  minWidth: 132,
  background: "#FFFFFF",
  border: "1px solid rgba(15, 61, 97, 0.1)",
  borderRadius: "4px",
  color: "#6F7784",
  fontWeight: 500,
  fontSize: 12,
  lineHeight: "16px",
  textTransform: "none",
  justifyContent: "space-between",
  "&:hover": {
    background: "#FFFFFF",
    border: "1px solid rgba(15, 61, 97, 0.1)",
  },
};

const UPLOAD_FILTER_PAPER: SxProps = {
  minWidth: 220,
  maxHeight: 204,
  background: "#FFFFFF",
  boxShadow: "0px 2px 8px rgba(171, 174, 186, 0.44)",
  borderRadius: "0px 0px 4px 4px",
  padding: "12px",
};

const UPLOAD_DATE_FILTER_PAPER: SxProps = {
  background: "#FFFFFF",
  boxShadow: "0px 2px 8px rgba(171, 174, 186, 0.44)",
  borderRadius: "0px 0px 4px 4px",
  padding: "12px",
};

const UPLOAD_LIST_ITEM: SxProps = {
  fontSize: 12,
  lineHeight: "14px",
  fontWeight: 500,
  letterSpacing: "0.44px",
  color: "#23242A",
};

const UPLOAD_OVERVIEW_CAPTION: SxProps = {
  fontSize: 12,
  lineHeight: "16px",
  fontWeight: 500,
  color: "#282C36",
};

const UPLOAD_NAVIGATION_BTN_ALT: SxProps = {
  height: 40,
  background: "#0F3D61",
  borderRadius: "8px",
  color: "#FFFFFF",
  fontWeight: 500,
  fontSize: 14,
  lineHeight: "19px",
  textTransform: "capitalize",
  "&:hover": {
    background: "#0F3D61",
  },
};

const FILTER_BUTTON: SxProps = {
  fontWeight: 500,
  fontSize: 12,
  lineHeight: "24px",
  color: "#0F3D61",
  textTransform: "none",
};

const PRODUCT_TITLE: SxProps = {
  fontWeight: 600,
  fontSize: 13,
  lineHeight: "24px",
  color: "#282C36",
};

const APPROVAL_CHIP: SxProps = {
  background: "#E7F3ED",
  height: 24,
  borderRadius: "4px",
  fontSize: 12,
  lineHeight: "16px",
  color: "#077942",
  fontWeight: 500,
};

const PENDING_CHIP: SxProps = {
  background: "#FAF3E3",
  height: 24,
  borderRadius: "4px",
  fontSize: 12,
  lineHeight: "16px",
  color: "#B04509",
  fontWeight: 500,
};

const ITEM_CARD_SELECT_WRAPPER: SxProps = {
  padding: "8px 8px 0 12px",
  background: "rgba(250, 243, 227, 0.4)",
  borderRadius: "4px",
};

const ITEM_CARD_FILTER_PAPER: SxProps = {
  background: "#FFFFFF",
  boxShadow: "0px 2px 10px rgba(171, 174, 186, 0.24)",
  border: "1px solid rgba(213, 215, 220, 0.7)",
  borderRadius: "4px",
  padding: "16px",
  width: 344,
};

const ITEM_CARD_FILTER_HEADER: SxProps = {
  fontWeight: 600,
  fontSize: 16,
  lineHeight: "22px",
  letterSpacing: "0.44px",
  color: "#282C36",
  textAlign: "center",
};

const ITEM_CARD_FILTER_LABEL: SxProps = {
  fontSize: 12,
  lineHeight: "16px",
  fontWeight: 500,
  color: "#6F7784",
  textTransform: "none",
  "&.Mui-focused": {
    color: "#0047D1",
    fontSize: 16,
    lineHeight: "24px",
  },
};

const ITEM_CARD_FILTER_SELECT: SxProps = {
  paddingY: "8px",
  backgroundColor: "rgba(111, 119, 132, 0.03)",
  borderRadius: "4px",
  height: 56,
  ":before": { borderBottomColor: "transparent" },
  // // underline when selected
  ":after": {
    borderBottomColor: "#0047D1",
  },
  "& .MuiSelect-iconFilled": {
    fontSize: 20,
    color: "#6F7784",
  },
};

const ITEM_CARD_FILTER_MENU: SxProps = {
  "& .MuiMenu-paper": {
    padding: "12px",
    paddingTop: 0,
    background: "#FFFFFF",
    borderWidth: "0px 1px 1px 1px",
    borderStyle: "solid",
    borderColor: "rgba(213, 215, 220, 0.7)",
    boxShadow: "0px 4px 8px rgba(15, 61, 97, 0.08)",
    borderRadius: "0px 0px 4px 4px",
    maxHeight: 168,
    overflow: "auto",
  },
  "& .MuiMenu-list": {
    padding: 0,
    maxWidth: 270,
  },
};

const ITEM_CARD_FILTER_MENUITEM_WRAPPER: SxProps = {
  height: 32,
  marginY: 0.25,
  padding: "6px 8px",
  "&.Mui-selected": {
    backgroundColor: "rgba(241, 242, 243, 0.54)",
  },
};

const ITEM_CARD_FILTER_MENUITEM: SxProps = {
  fontWeight: 500,
  fontSize: 12,
  lineHeight: "16px",
  color: "#282C36",
  whiteSpace: "normal",
};

const ITEM_CARD_FILTER_SUBHEADER: SxProps = {
  lineHeight: "32px",
  paddingY: "12px",
};

const ITEM_CARD_FILTER_CLEAR_BTN: SxProps = {
  minWidth: 103,
  height: 34,
  background: "rgba(15, 61, 97, 0.04)",
  borderRadius: "4px",
  fontWeight: 500,
  fontSize: 14,
  lineHeight: "24px",
  color: "rgba(40, 44, 54, 0.74)",
  textTransform: "none",
  boxShadow: "none",
  "&:hover": {
    background: "rgba(15, 61, 97, 0.04)",
    color: "rgba(40, 44, 54, 0.74)",
    boxShadow: "none",
  },
};

const ITEM_CARD_FILTER_APPLY_BTN: SxProps = {
  minWidth: 103,
  height: 34,
  background: "#0F3D61",
  borderRadius: "4px",
  fontWeight: 500,
  fontSize: 14,
  lineHeight: "24px",
  color: "#FFFFFF",
  textTransform: "none",
  boxShadow: "none",
  "&:hover": {
    background: "#0F3D61",
    color: "#FFFFFF",
    boxShadow: "none",
  },
};

const ITEM_CARD_FILTER_SELECTION: SxProps = {
  background: "#F1F4F9",
  padding: "1px 8px",
  borderRadius: "4px",
  cursor: "pointer",
};

const ITEM_CARD_FILTER_COUNT: SxProps = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "#282C36",
  padding: "1px 4px",
  borderRadius: "4px",
  minWidth: 18,
  height: 18,
  textAlign: "center",
  fontSize: 12,
  lineHeight: "16px",
  color: "#FFFFFF",
  fontWeight: 600,
};

const ITEM_CARD_FILTER_TEXT: SxProps = {
  fontSize: 12,
  lineHeight: "16px",
  color: "#282C36",
  fontWeight: 500,
};

const WARNING_DAILOG_WRAPPER: SxProps = {
  width: 453,
  background: "#FDFDFD",
  borderRadius: "12px",
  padding: 3,
};

const WARNING_DAILOG_HEADER: SxProps = {
  padding: 2,
  background: "rgba(250, 243, 227, 0.74)",
  borderRadius: "4px",
};

const WARNING_DAILOG_TITLE: SxProps = {
  fontSize: 16,
  lineHeight: "22px",
  color: "#B04509",
  fontWeight: 600,
};

const WARNING_DAILOG_TEXT: SxProps = {
  fontSize: 12,
  lineHeight: "16px",
  color: "#B04509",
};

const WARNING_DAILOG_ACTION_TEXT: SxProps = {
  fontSize: 12,
  lineHeight: "16px",
  fontWeight: 600,
  color: "#282C36",
};

const WARNING_DAILOG_ACTION_NO: SxProps = {
  background: "rgba(15, 61, 97, 0.04)",
  borderRadius: "4px",
  height: 32,
  fontSize: 12,
  lineHeight: "24px",
  fontWeight: 500,
  textTransform: "none",
  letterSpacing: "0.44px",
  color: "#000000",
  boxShadow: "none",
  "&:hover": {
    background: "rgba(15, 61, 97, 0.04)",
    color: "#000000",
    boxShadow: "none",
  },
};

const WARNING_DAILOG_ACTION_YES: SxProps = {
  background: "#0F3D61",
  borderRadius: "4px",
  height: 32,
  fontSize: 12,
  lineHeight: "24px",
  fontWeight: 500,
  textTransform: "none",
  letterSpacing: "0.44px",
  color: "#F1F2F3",
  boxShadow: "none",
  "&:hover": {
    background: "#0F3D61",
    color: "#F1F2F3",
    boxShadow: "none",
  },
};

const TEXT_BTN: SxProps = {
  fontSize: 12,
  lineHeight: "24px",
  fontWeight: 600,
  textTransform: "none",
  color: "#0F3D61",
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none",
  },
};

const SEARCH_LABEL: SxProps = {
  fontSize: 14,
  lineHeight: "19px",
  color: "#282C36",
  fontWeight: 500,
};

const CHOOSE_IMG_BTN: SxProps = {
  minWidth: 102,
  height: 30,
  background: "transparent",
  border: "2px solid #F1F4F9",
  borderRadius: "3px",
  fontSize: 10,
  lineHeight: "14px",
  fontWeight: 600,
  textTransform: "none",
  color: "#0F3D61",
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none",
    background: "transparent",
    border: "2px solid #F1F4F9",
  },
};

const IMAGE_DROPZONE: SxProps = {
  width: "100%",
  minHeight: 104,
  maxHeight: 104,
  minWidth: 400,
  background: "rgba(241, 242, 243, 0.24)",
  border: "1px dashed #D5D7DC",
  boxSizing: "border-box",
  borderRadius: "4px",
  padding: "22px 0",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  flex: 1,
};

const IMAGE_UPLOAD_DROP_TEXT: SxProps = {
  fontWeight: 500,
  fontSize: 14,
  lineHeight: "19px",
  color: "#6F7784",
};

const PRODUCT_IMAGE_MODAL: SxProps = {
  maxHeight: 630,
  minWidth: "58%",
  maxWidth: 1140,
  width: "100%",
  background: "#FFFFFF",
  borderRadius: "8px",
  padding: 3,
};

const PRODUCT_IMAGE_MODAL_HEADER: SxProps = {
  fontSize: 20,
  lineHeight: "27px",
  fontWeight: 600,
  color: "#282C36",
};

const PRODUCT_IMAGE_BUTTON: SxProps = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: 120,
  height: 120,
  padding: 1,
  "&:hover": {
    boxShadow: "none",
    background: "transparent",
    border: "none",
  },
  "& .hidden-button": {
    display: "none",
  },
  "&:hover .hidden-button": {
    display: "flex",
  },
};

const PRODUCT_IMAGE_WRAPPER: SxProps = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: 120,
  height: 120,
  padding: "6px",
  position: "relative",
};

const PRODUCT_IMAGE_PRIMARY_WRAPPER: SxProps = {
  position: "absolute",
  bottom: "2px",
  height: 26,
  width: "90%",
  background: "#077942",
  borderRadius: "4px 4px 0px 0px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const PRODUCT_IMAGE_PRIMARY_TEXT: SxProps = {
  fontSize: 12,
  lineHeight: "16px",
  fontWeight: 500,
  color: "#FFFFFF",
  textTransform: "none",
};

const IMG_TYPE_BTN: SxProps = {
  height: 28,
  background: "#FFFFFF",
  border: "1px solid rgba(15, 61, 97, 0.1) !important",
  borderRadius: "4px !important",
  fontSize: 12,
  lineHeight: "16px",
  fontWeight: 500,
  textTransform: "none",
  color: "#6F7784",
  boxShadow: "none",
  marginRight: 1,
  "&:hover": {
    boxShadow: "none",
    background: "#FFFFFF",
    border: "1px solid rgba(15, 61, 97, 0.1)",
  },
  "&.Mui-selected": {
    background: "#0F3D61",
    border: "1px solid #0F3D61",
    color: "#FFFFFF",
    "&:disabled": {
      opacity: 0.54,
    },
  },
};

const CAROUSEL_HEADER: SxProps = {
  fontSize: 20,
  lineHeight: "27px",
  fontWeight: 600,
  color: "#3A3C46",
};

const CAROUSEL_BTN: SxProps = {
  width: 32,
  height: 32,
  background: "#FFFFFF",
  border: "1px solid rgba(15, 61, 97, 0.1)",
  borderRadius: "30px",
  position: "absolute",
  color: "#0F3D61",
  zIndex: 2,
  "&:hover": {
    boxShadow: "none",
    background: "#FFFFFF",
    border: "1px solid rgba(15, 61, 97, 0.1)",
  },
};

const HELPER_TEXT: SxProps = {
  fontSize: 12,
  lineHeight: "16px",
  fontWeight: 500,
  color: "#BA0C2F",
};

const IMAGE_DEL_BTN: SxProps = {
  width: 22,
  height: 22,
  background: "rgba(15, 61, 97, 0.04)",
  borderRadius: "4px",
  marginRight: 1,
  "&:hover": {
    background: "rgba(15, 61, 97, 0.04)",
  },
};

const IMAGE_META_TEXT: SxProps = {
  fontSize: 13,
  lineHeight: "18px",
  fontWeight: 500,
  color: "#6F7784",
};

const CHECKBOX_LABEL: SxProps = {
  fontSize: 12,
  lineHeight: "16px",
  fontWeight: 500,
  color: "#282C36",
  marginLeft: 0,
};

const ACTIVITY_MODAL_TITLE_WRAPPER: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const ACTIVITY_MODAL_TITLE_TEXT: SxProps = {
  fontSize: 20,
  lineHeight: "27px",
  fontWeight: 600,
  color: "#282C36",
};

const ACTIVITY_MODAL_SUBTITLE_TEXT: SxProps = {
  fontSize: 14,
  lineHeight: "19px",
  fontWeight: 600,
  color: "#282C36",
};

const ACTIVITY_MODAL_LISTITEM: SxProps = {
  height: 24,
  marginY: 0.25,
  padding: "5px 12px",
  "&.Mui-selected": {
    backgroundColor: "#F1F8ED",
    borderRadius: "4px",
  },
};

const ACTIVITY_MODAL_TIMELINE_WRAPPER: SxProps = {
  [`& .${timelineItemClasses.root}:before`]: {
    flex: 0,
    padding: 0,
  },
};

const ACTIVITY_MODAL_TIMELINE_DOT: SxProps = {
  background: "transparent",
  boxShadow: "none",
  padding: 1,
  border: "none",
  margin: 0,
};

const ACTIVITY_MODAL_TIMELINE_DOT_LABEL: SxProps = {
  fontSize: 12,
  lineHeight: "16px",
  fontWeight: 500,
  color: "#6F7784",
};

const ACTIVITY_MODAL_TIMELINE_CONNECTOR: SxProps = {
  width: "1px",
  backgroundColor: "rgba(213, 215, 220, 0.7)",
};

const ACTIVITY_MODAL_TIMELINE_CONTENT_WRAPPER: SxProps = {
  padding: "12px",
  background: "#FFFFFF",
  border: "1px solid #ECECEC",
  borderRadius: "4px",
  boxSizing: "border-box",
  marginBottom: 1,
};

const ACTIVITY_MODAL_TIMELINE_CONTENT_TITLE: SxProps = {
  fontSize: 14,
  lineHeight: "19px",
  fontWeight: 500,
  color: "#282C36",
};

const ACTIVITY_MODAL_TIMELINE_CONTENT_CAPTION: SxProps = {
  fontSize: 11,
  lineHeight: "15px",
  fontWeight: 500,
  color: "#6F7784",
};

const ACTIVITY_MODAL_TIMELINE_CONTENT_TEXT: SxProps = {
  fontSize: 12,
  lineHeight: "16px",
  fontWeight: 500,
  color: "#282C36",
};

const STATUS_BTN: SxProps = {
  minWidth: 159,
  height: 30,
  padding: "6px 8px 6px 12px",
  background: "rgba(229, 237, 250, 0.84)",
  border: "none",
  borderRadius: "22px",
  color: "#0F3D61",
  fontSize: 12,
  lineHeight: "16px",
  fontWeight: 500,
  textTransform: "none",
  boxShadow: "none",
  justifyContent: "space-around",
};

const STATUS_MENULIST_WRAPPER: SxProps = {
  width: 160,
  background: "#FFFFFF",
  boxShadow: "0px 2px 8px rgba(171, 174, 186, 0.44)",
  borderRadius: "0px 0px 4px 4px",
  padding: "12px",
};

const STATUS_MENUITEM: SxProps = {
  height: 32,
  background: "rgba(250, 243, 227, 0.84)",
  borderRadius: "4px",
  padding: "8px 8px 8px 12px",
  marginBottom: 0.5,
  whiteSpace: "normal",
};

const STATUS_MENUITEM_TEXT: SxProps = {
  fontSize: 12,
  lineHeight: "16px",
  color: "#282C36",
  fontWeight: 500,
};

const CARD_SAVE_BTN: SxProps = {
  minWidth: 52,
  height: 30,
  background: "#E9F1F3",
  borderRadius: "4px",
  padding: "6px 12px",
  fontSize: 12,
  lineHeight: "18px",
  fontWeight: 500,
  color: "#25728A",
  textTransform: "none",
  boxShadow: "none",
  border: "none",
  "&:hover": {
    background: "#E9F1F3",
    boxShadow: "none",
    border: "none",
  },
  "&.Mui-disabled": {
    cursor: "not-allowed",
  },
};

const UPLOAD_WARNING_WRAPPER: SxProps = {
  background: "rgba(250, 243, 227, 0.74)",
  borderRadius: "4px",
  padding: 2,
  width: "100%",
};

const UPLOAD_INFO_WRAPPER: SxProps = {
  background: "rgba(242, 234, 251, 0.54)",
  borderRadius: "4px",
  padding: 2,
  width: "100%",
};

const UPLOAD_SUCCESS_WRAPPER: SxProps = {
  background: "rgba(231, 243, 237, 0.74)",
  borderRadius: "4px",
  padding: 2,
  width: "100%",
};

const UPLOAD_CANCEL_BTN: SxProps = {
  height: 34,
  background: "rgba(15, 61, 97, 0.04)",
  borderRadius: "4px",
  color: "rgba(40, 44, 54, 0.74)",
  fontWeight: 500,
  fontSize: 14,
  lineHeight: "18px",
  textTransform: "none",
  border: "none",
  boxShadow: "none",
  "&:hover": {
    background: "rgba(15, 61, 97, 0.04)",
    border: "none",
    boxShadow: "none",
  },
};

const UPLOAD_YES_BTN: SxProps = {
  height: 34,
  background: "#0F3D61",
  borderRadius: "4px",
  color: "#FFFFFF",
  fontWeight: 500,
  fontSize: 14,
  lineHeight: "18px",
  textTransform: "none",
  border: "none",
  boxShadow: "none",
  "&:hover": {
    background: "#0F3D61",
    border: "none",
    boxShadow: "none",
  },
};

const ENQUEUE_NUMBER: SxProps = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: 24,
  height: 24,
  borderRadius: "4px",
};

export {
  BACKDROP_WRAPPER,
  LOADING_WRAPPER,
  APPBAR,
  TOOLBAR_WRAPPER,
  HEADER_ICON,
  USERNAME,
  EMAIL,
  USER_MENU_DIVIDER,
  USER_MENU_ITEM,
  UPLOAD_TITLE,
  DROPZONE_WRAPPER,
  DROPZONE,
  UPLOAD_DROP_TEXT,
  UPLOAD_FILE_CONTAINER,
  UPLOAD_FILE_NAME,
  UPLOAD_FILE_SIZE,
  UPLOAD_BUTTON,
  UPLOAD_DEL_BTN,
  UPLOAD_SUBTITLE,
  UPLOAD_CAPTION,
  PRODUCT_WRAPPER,
  BASE_INPUT,
  INPUT_WRAPPER,
  ITEM_CARD_WRAPPER,
  PAGINATION_WRAPPER,
  PAGINATION_CONTAINER,
  ITEM_CARD_LABEL,
  ITEM_CARD_SELECT_MENU,
  SAVE_BTN,
  SELECTION_TEXT,
  ITEM_CARD_DIVIDER,
  ITEM_CARD_PAPER,
  ITEM_CARD_MENU_ITEM,
  UPLOAD_CONTAINER,
  UPLOAD_NAVIGATION_BTN,
  UPLOAD_DATA_CONTAINER,
  DROPZONE_FILE,
  UPLOAD_FILTER_BUTTON,
  UPLOAD_FILTER_PAPER,
  UPLOAD_LIST_ITEM,
  UPLOAD_DATE_FILTER_PAPER,
  UPLOAD_OVERVIEW_CAPTION,
  UPLOAD_NAVIGATION_BTN_ALT,
  UPLOAD_RESET_BTN,
  AVATAR_INITIALS,
  PRODUCT_FILTER_WRAPPER,
  FILTER_BUTTON,
  PRODUCT_TITLE,
  APPROVAL_CHIP,
  PENDING_CHIP,
  ITEM_CARD_VALUE,
  ITEM_CARD_SELECT_WRAPPER,
  ITEM_CARD_FILTER_PAPER,
  ITEM_CARD_FILTER_HEADER,
  ITEM_CARD_FILTER_LABEL,
  APP_CONTAINER,
  ITEM_CARD_FILTER_SELECT,
  ITEM_CARD_FILTER_MENU,
  ITEM_CARD_FILTER_MENUITEM,
  ITEM_CARD_FILTER_SUBHEADER,
  ITEM_CARD_FILTER_CLEAR_BTN,
  ITEM_CARD_FILTER_APPLY_BTN,
  ITEM_CARD_FILTER_SELECTION,
  ITEM_CARD_FILTER_COUNT,
  ITEM_CARD_FILTER_TEXT,
  ITEM_CARD_FILTER_MENUITEM_WRAPPER,
  WARNING_DAILOG_WRAPPER,
  WARNING_DAILOG_HEADER,
  WARNING_DAILOG_TITLE,
  WARNING_DAILOG_TEXT,
  WARNING_DAILOG_ACTION_TEXT,
  WARNING_DAILOG_ACTION_NO,
  WARNING_DAILOG_ACTION_YES,
  TEXT_BTN,
  SEARCH_LABEL,
  CHOOSE_IMG_BTN,
  IMAGE_DROPZONE,
  IMAGE_UPLOAD_DROP_TEXT,
  PRODUCT_IMAGE_MODAL,
  PRODUCT_IMAGE_MODAL_HEADER,
  PRODUCT_IMAGE_BUTTON,
  PRODUCT_IMAGE_PRIMARY_TEXT,
  PRODUCT_IMAGE_PRIMARY_WRAPPER,
  APP_SUB_CONTAINER,
  IMG_TYPE_BTN,
  CAROUSEL_HEADER,
  CAROUSEL_BTN,
  HELPER_TEXT,
  PRODUCT_IMAGE_WRAPPER,
  IMAGE_DEL_BTN,
  IMAGE_META_TEXT,
  CHECKBOX_LABEL,
  ACTIVITY_MODAL_TITLE_WRAPPER,
  ACTIVITY_MODAL_TITLE_TEXT,
  ACTIVITY_MODAL_SUBTITLE_TEXT,
  ACTIVITY_MODAL_LISTITEM,
  ACTIVITY_MODAL_TIMELINE_WRAPPER,
  ACTIVITY_MODAL_TIMELINE_DOT,
  ACTIVITY_MODAL_TIMELINE_DOT_LABEL,
  ACTIVITY_MODAL_TIMELINE_CONNECTOR,
  ACTIVITY_MODAL_TIMELINE_CONTENT_WRAPPER,
  ACTIVITY_MODAL_TIMELINE_CONTENT_TITLE,
  ACTIVITY_MODAL_TIMELINE_CONTENT_CAPTION,
  ACTIVITY_MODAL_TIMELINE_CONTENT_TEXT,
  STATUS_BTN,
  STATUS_MENULIST_WRAPPER,
  STATUS_MENUITEM,
  STATUS_MENUITEM_TEXT,
  CARD_SAVE_BTN,
  UPLOAD_WARNING_WRAPPER,
  UPLOAD_INFO_WRAPPER,
  UPLOAD_SUCCESS_WRAPPER,
  UPLOAD_CANCEL_BTN,
  UPLOAD_YES_BTN,
  ENQUEUE_NUMBER
};
